import { Box, Stack } from "@mui/material";
import { FormSection } from "Components/Shared/FormSection";
import { FormInputWithLabelSkeleton } from "Components/Shared/Inputs/Form/FormInputWithSkeleton";
import { ValueItemsSkeleton } from "Components/Shared/ValuesBox/ValueItemsSkeleton";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { Resources, useResource } from "Translations/Resources";

export const MerchantPartySkeleton = () => {
  const { t } = useResource();

  return (
    <>
      <Box mb={5}>
        <ValuesBox title={t(Resources.Common.GeneralInfo)}>
          <ValueItemsSkeleton
            labels={[
              t(Resources.Common.CompanyName),
              t(Resources.Common.CompanyNumber),
              t(Resources.Common.PartyTypeLabel),
              t(Resources.Common.Address.Title),
            ]}
          />
        </ValuesBox>
      </Box>
      <FormSection legend={t(Resources.Common.Contact)}>
        <Stack>
          <FormInputWithLabelSkeleton />
          <FormInputWithLabelSkeleton />
        </Stack>
      </FormSection>
    </>
  );
};
